import { Component, OnInit, Input, Inject, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckbox } from '@angular/material/checkbox';
import { DatePipe } from '@angular/common';
import { AddToucheStatusTypeComponent } from '../addtouchestatustype/addtouchestatustype.component';
import { AddCustomInfoTypeComponent } from '../addcustomInfotype/addcustomInfotype.component';
import { AddCustomInfoStatusTypeComponent } from '../addcustominfostatustype/addcustominfostatustype.component';


@Component({
  selector: 'app-addCustomInfo',
  templateUrl: './addCustomInfo.component.html',
  styleUrls: ['./addCustomInfo.component.scss'] 
})

export class AddCustomInfoComponent implements OnInit {

  @Input() modulename: string;  
  @Input() entityID:number;
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;

  myCustomInfoForm: FormGroup;
  CustomInfoType :any[]=[];
  CustomInfoTypeForFilter :any[]=[];
  AllContactTouchesList  :any[]=[];
  folderList: any[] = []; 
  folderId:number=0;
  getTagListResponseHolder: any;
  formDialog: FormGroup;
  OpenAddTouch:boolean=false;
  OfficeIDList: any=[];
  myOfficeID: any;
  showDateTime:boolean=false;
  transactionIdFromPortal:number=0;

  statusList:any=[]=[];


  constructor(private dialog: MatDialog,private dialog1: MatDialog,private datePipe: DatePipe, public dialogRef: MatDialogRef<AddCustomInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService ) {  
     
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    }     
  }  
  
  ngOnInit(): void {
    let group = {};
    this.myCustomInfoForm = new FormGroup(group);
    this.createFormCustomInfo();
    this.getCustomInfoTypeList();
    if(this.data && this.data.touch && this.data.touch.touchID>0){
      this.showStatusButton=true;
      this.custominfoTypeName=this.data.touch.touchTypeName;
    }else{
      this.showStatusButton=false;
    }
  }


  // get custominfo type ==//
 getCustomInfoTypeList() {
  if(this.data.moduleName=="Portal"){
    this.organizationId= this.data.organizationID;
    this.myOfficeID= this.data.officeID;  
    this.transactionIdFromPortal = this.data.transactionId;  
  }
  var ReqModel={
   databaseId:Number(this.databaseId),
   organizationID:Number(this.organizationId),
   officeID:this.myOfficeID,
   userId: this.currentUser.UID,
  }
   this.settingsService.getCustomInfoTypes(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.getTagListResponseHolder = response;
      if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
        this.CustomInfoType = this.getTagListResponseHolder.data;
        if(this.data && this.data.customInfo && this.data.customInfo.customNoteID>0){
          this.getAllCustomInfoStatus(this.data.customInfo.customNoteTypeID);
           // Set values to form controls
            this.myCustomInfoForm.patchValue({
              customNoteType: this.data.customInfo.customNoteTypeID,
              customNoteStatus: this.data.customInfo.customNoteStatus,
              customNote: this.data.customInfo.customNote,           
            });           
          }        
       }
      else {
      }
    }
  });
  }

   // get custom info Status ==//
   getAllCustomInfoStatus(customNoteTypeID) {  
    var userId;
    if(this.data.moduleName=="Portal"){
      this.organizationId= this.data.organizationID;
      this.myOfficeID= this.data.officeID;  
      this.transactionIdFromPortal = this.data.transactionId;
      userId="2503b67f-bd65-4649-ab35-91348d4c4100";
      this.databaseId="1";
    }else{
      userId=this.currentUser.UID;
    }
  var ReqModel={
    customNoteTypeID:Number(customNoteTypeID),
    userId: userId,
    databaseId:Number(this.databaseId),
    organizationID:Number(this.organizationId),
    officeID:this.myOfficeID,
   }
   this.settingsService.getStatusesByCustomInfoType(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.getTagListResponseHolder = response;
      if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
        this.statusList = this.getTagListResponseHolder.data;            
      }
      else {
      }
    }
  });
  }

  // Create custom info
  createFormCustomInfo(): void {
    this.myCustomInfoForm = this.formBuilder.group({
      customNoteType: ['', [Validators.required]],      
      customNoteStatus: ['', [Validators.required]],            
      customNote: ['', [Validators.required]],  
      viewOn:[false]  
    },);
  }
  
  close() {
    this.myCustomInfoForm.reset();
    this.dialog.closeAll();
  }

  

  async SaveCustomInfoDetail(data) {
    this.data;
    var modulename = this.data.moduleName;   
    if(this.data.moduleName!="Portal"){
      this.AddCustomInfo(data);
      this.myCustomInfoForm.reset();
    }   
  }


  async AddCustomInfo(data) {
    var showOnPortal;
    if(data.viewOn==true){
      showOnPortal=1;
    }else{
      showOnPortal=0;
    }
    var cType=0;
    if(this.data.moduleName=="Core"){
      cType=1;
    }
    if(this.data.moduleName=="Contact"){
      cType=2;
    }
    if(this.data.moduleName=="Company"){
      cType=3;
    }
    var ReqModel={
      customNoteID:0,
      customNoteTypeID:data.customNoteType,
      customNoteStatus:data.customNoteStatus,     
      customNote:data.customNote,
      cType:cType,
      transactionID:Number(sessionStorage.getItem('transactionID')),  
      organizationID:Number(this.organizationId),
      databaseID:0,
      userID:this.currentUser.UID,
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList,
      viewOn:showOnPortal//data.viewOn
    }
    
    this.spinner=true;
    this.myCustomInfoForm.markAsPristine();
    if(this.data && this.data.customInfo && this.data.customInfo.customNoteID>0){
      ReqModel.customNoteID=this.data.customInfo.customNoteID;
      const result = await this.coreService.updateCustomInfo(ReqModel).toPromise();
      if (result.status === this.statusConst.statusSuccess) {
        this.spinner=false; 
        this.dialogRef.close('Added');
        this.toastr.success("Custom info updated successfully.", '', {
          timeOut: 3000,
        });      
      }
      else { 
        this.spinner=false;
        this.dialogRef.close('Error');
      }
    }else{
    const result = await this.coreService.AddCustomInfo(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false; 
      this.dialogRef.close('Added');
      this.toastr.success("Custom info created successfully.", '', {
        timeOut: 3000,
      });      
     }
    else { 
      this.spinner=false;
      this.dialogRef.close('Error');
    }
   } 
  }

  

  spinner:boolean=false;
  
  openDialogAddWithRef() {
    const dialogRef = this.dialog.open(AddCustomInfoTypeComponent, {     
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.getCustomInfoTypeList();
      }  
    });     
  }

  openDialogAddStatusWithRef() {
    const dialogRef = this.dialog.open(AddCustomInfoStatusTypeComponent, {
      data: {
        customInfoTypeID:this.myCustomInfoForm.get('customNoteType').value,
        customInfoName: this.custominfoTypeName 
      }     
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.getAllCustomInfoStatus(this.myCustomInfoForm.get('customNoteType').value);
        if(result>0){
          this.myCustomInfoForm.controls['customNoteStatus'].setValue(result);
        }        
      }  
    });     
  }

  closeAddTouchType(){
    this.formDialog.reset();    
    this.dialogRef.close();
  }

 

 showStatusButton:boolean=false;
 custominfoTypeName:string="";

 DropDownCustomInfoType(event){
  this.showStatusButton=true;
  var data=[];
  data =this.CustomInfoType.filter(x=>x.customInfoTypeID==event.value);
  if(data.length>0){
    this.custominfoTypeName=data[0].customInfoName;
  }
  this.getAllCustomInfoStatus(event.value);
 }
  
}
